import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

export const setSelectedMachineGroupIdAction = (state: PlanboardState, action: PayloadAction<number | null>) => {
  state.selectedMachineGroupId = action.payload;
};
